<template>
	<router-view/>
</template>

<script>
export default {
	name: "StudyView"
};
</script>

<style lang="scss">

</style>
